const accounts = {
    title: "Auswahl des Kontos von {professional}",
    tab: "Kontoauswahl"
}

export default accounts;